<template>
    <div >
      <Card>
            <p slot="title">
                Item Dept
            </p>
                <Button
                    v-show="canCreateItemDept()"
                    type="primary"
                    slot="extra"
                    @click="modal.createItemDept=true"
                    size="small"  >
                    Tambah
                </Button>
                <template>
                        <Table border :columns="columnTableItemDept" :data="itemDept"></Table>

                </template>
        </Card>
        <template>
            <Modal v-model="modal.createItemDept" width="500px">
                <p slot="header" style="color:#2d8cf0;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Tambah Item</span>
                </p>
                        <Form ref="formItemDept" :model="formItemDept" :rules="ruleValidate">
                            <Form-item label="Dept Name" prop="deptName">
                                <Input v-model="formItemDept.deptName" placeholder="Dept Name"></Input>
                            </Form-item>
                        </Form>
                <div slot="footer">
                    <Button
                        v-show="true"
                        type="primary"
                        :loading="loadingCreateItemDept"
                        @click="postCreateItemDept" >
                        <span v-if="!loadingCreateItemDept">Simpan</span>
                        <span v-else>Wait.....</span>
                    </Button>
                </div>
            </Modal>
        </template>
        <template>
            <Modal v-model="modal.editItemDept" width="500px">
                <p slot="header" style="color:#2d8cf0;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Edit Item</span>
                </p>
                <Form ref="formEditItemDept" :model="formEditItemDept" :rules="ruleValidate">
                    <Form-item label="Dept Name" prop="deptName">
                        <Input style="display: none;" v-model="formEditItemDept.id" placeholder="Id Dept Name"></Input>
                        <Input v-model="formEditItemDept.deptName" placeholder="Dept Name"></Input>
                    </Form-item>
                </Form>
                <div slot="footer">
                    <Button
                        v-show="true"
                        type="primary"
                        :loading="loadingEditItemDept"
                        @click="postEditItemDept" >
                        <span v-if="!loadingEditItemDept">Edit</span>
                        <span v-else>Wait.....</span>
                    </Button>
                </div>
            </Modal>
        </template>
    </div>
</template>
<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'

export default {
    data () {
        return {


        user : {
            username : '',
            role : ''
        },
        modal : {
            createItemDept : false,
            editItemDept : false,
        } ,
        loadingSearch: false,
        loadingCreateItemDept: false,
        loadingEditItemDept: false,
        itemDept : [],
        formItemDept: {
            deptName: '',
        },
        formEditItemDept: {
            deptName: '',
        },
        ruleValidate: {
            deptName: [
                { required: true, message: 'Masukkan Dept Name', trigger: 'blur' }
            ],
        },
        columnTableItemDept: [
            {
                title: 'Dept Name',
                key: 'deptName'
            },
            {
                title: 'Action',
                key: 'action',
                width: 120,
                align: 'center',
                render: (h, params) => {
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'success',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    this.show(params.index)
                                }
                            }
                        }, 'Edit')
                    ]);
                }
            }
        ],
    }},

  methods: {
    canCreateItemDept () {
        let canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR'], this.user.role);
        //console.log('this.user.role = ' + this.user.role)
        //console.log('canAccess = ' + canAccess)
        return canAccess;
    },
    handleSubmit (name) {
        this.$refs[name].validate((valid) => {
            if (valid) {
                this.createitemDept();
            } else {
                this.$Message.error('Data masih belum lengkap');
            }
        })
    },
    show: function(index){
        var editItemDeptId = this.itemDept[index].id;
        this.formEditItemDept.id = editItemDeptId;

        var editDeptName = this.itemDept[index].deptName;
        this.formEditItemDept.deptName = editDeptName;
        //console.log(this.itemDept[index].id);
        this.modal.editItemDept = true;
    },
    getItemDept: function(){
        this.loadingSearch  = true;
        this.itemDept = []
        HTTP
            .get('itemDept')
            .then(response => {
                this.loadingSearch  = false;
                this.itemDept = response.data
            })
            .catch(e => {
            this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
            });
        })
    },
    postCreateItemDept:function(){
            this.loadingCreateItemDept = true;

            let deptNameExist = _.some(this.itemDept, {deptName: this.formItemDept.deptName });

            if(deptNameExist){
                this.$Message.error('Dept name sudah ada');
                this.loadingCreateItemDept = false;
                return false;
            }

            HTTP
            .post('itemDept/create', {
                deptName: this.formItemDept.deptName  ,
            })
            .then(response => {
                this.loadingCreateItemDept = false;
                this.modal.createItemDept = false;
                this.formItemDept.deptName = '';

                this.$Message.success('Item Dept Created');
                this.getItemDept();
            })
            .catch(e => {
                this.loadingCreateItemDept = false;
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })
    },
    postEditItemDept:function(){
            this.loadingEditItemDept = true;

            let deptNameExist = _.some(this.itemDept, {deptName: this.formEditItemDept.deptName });

            if(deptNameExist){
                this.$Message.error('Dept name sudah ada');
                this.loadingEditItemDept = false;
                return false;
            }

            HTTP
            .post('itemDept/update', {
                id: this.formEditItemDept.id  ,
                deptName: this.formEditItemDept.deptName  ,
            })
            .then(response => {
                this.loadingEditItemDept = false;
                this.modal.editItemDept = false;
                this.formEditItemDept.deptName = '';

                this.$Message.success('Item Dept Edited');
                this.getItemDept();
            })
            .catch(e => {
                this.loadingEditItemDept = false;
                this.$Notice.error({
                    title: "Error",
                    desc:e,
                    duration: 5
                });
            })
    }
  },
  created() {
      this.user.username = localStorage.getItem('user.username')
      this.user.role = localStorage.getItem('user.role')
      this.getItemDept();
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// ItemDept.vue?3696a06a